document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById("quick-view-modal");
  const quickViewTriggers = document.querySelectorAll(".quick-view-trigger-btn, .quick-view-trigger, .meal-name");
  
  let selectedProductId = null; // Store selected variant ID for add to cart

  var closeBtn = document.getElementsByClassName("close")[0];


  closeBtn.onclick = function() {
    modal.style.display = "none";
  }

  

  

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }

  quickViewTriggers.forEach(trigger => {
    trigger.addEventListener('click', function () {
      const productHandle = this.dataset.handle;
      selectedProductId = this.dataset.id;

      document.getElementById('quick-view-image').src = this.dataset.image;
      document.getElementById('quick-view-title').textContent = this.dataset.title;
      
      const addToPlanBtn = document.getElementById('add-to-my-plan');
      addToPlanBtn.classList.add('select-meal');
      addToPlanBtn.setAttribute('data-id', selectedProductId);
      addToPlanBtn.setAttribute('data-title', this.dataset.title);
      addToPlanBtn.setAttribute('data-image', this.dataset.image);
      addToPlanBtn.textContent = 'Add it to my plan';

      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          document.getElementById('quick-view-description').innerHTML = product.description; 
        })
        .catch(error => console.error('Error:', error));

      modal.style.display = "block";
    });
  });

  
});
